import type { UserPreferencesNotificationsProps } from "./user-preferences-notifications.type";

import { Flex, ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsFooter } from "./user-preferences-notifications-footer";
import { UserPreferencesNotificationsTable } from "./user-preferences-notifications-table";
import { useUserPreferencesNotifications } from "./user-preferences-notifications.hook";
import { notificationsTableTheme } from "./user-preferences-notifications.theme";

import "./user-preferences-notifications.style.less";

export const UserPreferencesNotifications = ({
  notificationsByType,
  userPreferencesNotifications,
}: UserPreferencesNotificationsProps) => {
  const { t } = useTranslation();

  const {
    notificationSettings,
    isPending,
    isDirty,
    onSave,
    onCancel,
    handleNotificationSettingsChange,
  } = useUserPreferencesNotifications({ userPreferencesNotifications });

  return (
    <ConfigProvider theme={notificationsTableTheme}>
      <Flex vertical className="user-preferences-notifications" gap={24}>
        {Object.entries(notificationsByType).map(([type, notifications]) => (
          <UserPreferencesNotificationsTable
            key={type}
            title={t(`user:preferences.notifications.groupsTitle.${type}`)}
            notifications={notifications}
            userPreferencesNotifications={notificationSettings}
            onNotificationSettingsChange={handleNotificationSettingsChange}
          />
        ))}
        <UserPreferencesNotificationsFooter
          isPending={isPending}
          isDirty={isDirty}
          onSave={onSave}
          onCancel={onCancel}
        />
      </Flex>
    </ConfigProvider>
  );
};
